import { string,bool,oneOfType } from 'prop-types';
import React from 'react';
import TooltipBase from './TooltipBase';
import style from './style';


const InfoTooltip = ({text,...props}) => {
	if(!text || text==='') return <span {...props}/>;
	return (
		<TooltipBase {...props}
			render={()=>(
				<React.Fragment>
					<style.InfoTooltip.InfoText> {text}</style.InfoTooltip.InfoText>
				</React.Fragment>
			)}
		/>
	);
};

InfoTooltip.propTypes = {
	text: oneOfType([
		string,
		bool,
	])
};

export default InfoTooltip;